module.exports = __webpack_public_path__ + "media/images/G-07-eb452d0524fbf7fea7e3ed3ba52eccfc.svg";